export default (axios) => ({
  createOrder(payload) {
    return axios.post("/order", payload);
  },
  getOrders(payload){
    return axios.post("/order/list", payload);
  },
  getOrderDetail(payload){
    return axios.post("/order/detail", payload);
  },
  cancelOrder(payload){
    return axios.post("/consultant/invoice/cancellation", payload);
  }
});
